
import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class extends Vue {
  value: string = '';
  @Prop() index!: number;
  @Prop() item!: string;
  deleteText() {
    this.$emit('deleteText', this.index);
  }
  AddText() {
    this.$emit('AddText');
  }
  changeValue() {
    this.$emit('change', this.index, this.value);
  }
  mounted() {
    this.value = this.item;
  }
}
